{
  "333": "Chọn Tỉnh/Thành Phố",
  "202": "Hồ Chí Minh",
  "201": "Hà Nội",
  "217": "An Giang",
  "219": "Kiên Giang",
  "209": "Lâm Đồng",
  "231": "Nam Định",
  "235": "Nghệ An",
  "260": "Phú Yên",
  "237": "Quảng Bình",
  "238": "Quảng Trị",
  "240": "Tây Ninh",
  "234": "Thanh Hóa",
  "223": "Thừa Thiên – Huế",
  "248": "Bắc Giang",
  "249": "Bắc Ninh",
  "262": "Bình Định",
  "239": "Bình Phước",
  "258": "Bình Thuận",
  "252": "Cà Mau",
  "210": "Đắk Lắk",
  "241": "Đắk Nông",
  "207": "Gia Lai",
  "232": "Hà Nam",
  "236": "Hà Tĩnh",
  "225": "Hải Dương",
  "250": "Hậu Giang",
  "268": "Hưng Yên",
  "208": "Khánh Hòa",
  "204": "Đồng Nai",
  "205": "Bình Dương",
  "206": "Bà Rịa – Vũng Tàu",
  "211": "Long An",
  "203": "Đà Nẵng",
  "212": "Tiền Giang",
  "213": "Bến Tre",
  "214": "Trà Vinh",
  "215": "Vĩnh Long",
  "216": "Đồng Tháp",
  "218": "Sóc Trăng",
  "220": "Cần Thơ",
  "221": "Vĩnh Phúc",
  "224": "Hải Phòng",
  "242": "Quảng Ngãi",
  "243": "Quảng Nam",
  "245": "Bắc Kạn",
  "246": "Cao Bằng",
  "247": "Lạng Sơn",
  "263": "Yên Bái",
  "267": "Hòa Bình",
  "230": "Quảng Ninh",
  "233": "Ninh Bình",
  "226": "Thái Bình",
  "227": "Hà Giang",
  "228": "Tuyên Quang",
  "229": "Phú Thọ",
  "264": "Lai Châu",
  "265": "Điện Biên",
  "266": "Sơn La",
  "259": "Kon Tum",
  "261": "Ninh Thuận",
  "269": "Lào Cai",
  "244": "Thái Nguyên",
  "253": "Bạc Liêu",
  "257": "Đồng Tháp"
}
